<template>
  <div class="seomain">
    <st-header
      title="供应商对账"
      :back-able="true"
			:more-op="[{val: 'openShowSearch', title: '搜索' }, { val: 'download', title: '下载对账单' }]"
			@command="headercommand"
    >
      <template slot="header-right">
        <!-- <span @click="addOrder()">
          <i class="el-icon-circle-plus"></i>
        </span> -->
      </template>
    </st-header>

    <ul class="tab-tilte four">
      <li
        v-for="(item, index) in tabs"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ item.title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
		

    <div class="tab-content tab-content-list">
			
			<!-- 搜索 多行 -->
			<div class="keyword">
        <div class="keyword-panel" v-if="showSearch">
          <div class="keyword-panel-head">
            <span class="keyword-panel-title">搜索筛选</span>
            <span class="keyword-panel-close" @click="showSearch = false">
              <van-icon name="cross" />
            </span>
          </div>
          <van-form class="keyword-form" @submit="onSearch">
					<st-select
						field-lable="供应商"
					  v-model="searchData.supplier_id"
					  name="供应商"
					  placeholder="请选择供应商"
					  :options="$option['getSupplier']"
						:clearable="true"
					>
					</st-select>
            <van-field v-model="searchData.code" label="付款单号" placeholder="请输入付款单号" />
            <van-field v-model="searchData.order_code" label="订单编号" placeholder="请输入订单编号" />
            <div class="keyword-form-actions keyword-form-actions-split">
              <button class="clearBtn" type="button" @click="clearSearch">清空条件</button>
              <button class="submitBtn" type="submit">搜 索</button>
            </div>
          </van-form>
        </div>
        <div class="keyword-collapsed" v-else @click="showSearch = true">
          <van-icon name="search" />
          <span>搜索供应商 / 单号</span>
        </div>
			</div>
      <div class="st-list-box pan-3">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				  <div class="st-list" v-for="(v, k) in stlist" :key="v.id" :index="k">
				    <div class="st-list-top st-list-top-with-status">
							<div class="t-tit">{{ v.code }}</div>
              <div class="t-status">{{ v.status_text || '--' }}</div>
				    </div>
				    <div class="st-list-main"
				    	@touchstart="touchstart"
				    	@touchmove="touchmove"
				    	@touchend="touchend"
				    	@click="checkItem(v.id)"
				    >
							<div class="list-checkbox" v-if="touchLong">
								<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
								<van-checkbox :value="checkList[v.id]"></van-checkbox>
							</div>
              <div class="st-field"><span class="st-field-label">付款单号</span><span class="st-field-value">{{ v.code || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">订单编号</span><span class="st-field-value">{{ v.order_code || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">付款单位</span><span class="st-field-value">{{ v.corporation || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">供应商</span><span class="st-field-value">{{ v.supplier || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">申请人</span><span class="st-field-value">{{ v.applicant_name || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">审批人</span><span class="st-field-value">{{ v.approver_name || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">付款人</span><span class="st-field-value">{{ v.payer_name || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">收款人</span><span class="st-field-value">{{ v.account_name || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">订单类型</span><span class="st-field-value">{{ v.order_type_text || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">付款类型</span><span class="st-field-value">{{ v.type_text || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">订单金额</span><span class="st-field-value">{{ v.total_money || '--' }} {{ v.currency || '' }}</span></div>
              <div class="st-field"><span class="st-field-label">付款金额</span><span class="st-field-value">{{ v.amount || '--' }} {{ v.currency || '' }}</span></div>
              <div class="st-field"><span class="st-field-label">创建时间</span><span class="st-field-value">{{ v.createdatetime || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">审核时间</span><span class="st-field-value">{{ v.reviewdatetime_text || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">付款时间</span><span class="st-field-value">{{ v.predicttime_text || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">实际付款时间</span><span class="st-field-value">{{ v.paymenttime_text || '--' }}</span></div>
				    </div>
						<div class="st-list-bottom-2">
							<!-- <div style="flex:1;padding:0px 8px;height:44px;display: none;">
								<div class="st-list-bottom-xs" style="background-color: orange;height: 42px;line-height: 42px;padding:0px;">
									<router-link :to="'/customer/save?id=' + v.id" class="st-opt-btn" style="margin-top: 8px;padding-top:14px;">编辑</router-link>
								</div>
							</div>
							<van-button v-if="v.status == 1"  @click="openApproveDetail(v.id)" type="primary" class="st-opt-btn" style="flex: 1;">审批详情</van-button> -->
							<!-- <van-button v-if="v.status == 0"  @click="approval(v.id)" type="info" class="st-opt-btn" style="flex: 1;">提交申请</van-button> -->
						</div>
				   
				  </div>
				</van-list>
			</div>
      
			<batch-btn
				v-if="touchLong"
				:options="batchBtnOptions[type]"
				@command="batchCommand"
			></batch-btn>
		</div>

  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import BatchBtn from "@/components/layout/BatchBtn.vue";
import StSelect from "@/components/Select.vue";
export default {
  components: {
    "st-header": StHeader,
		'batch-btn': BatchBtn,
		StSelect,
  },
  props: {},
	inject: ['reload'],
  data() {
    return {
      loading: false,
      finished: false,
			searchData: {},
      page: 1,
			tabs: [
				{ title: '全部', type: '0' },
				{ title: '待审核', type: '1' },
				{ title: '待付款', type: '2' },
				{ title: '已付款', type: '3' },
			],
      cur: 0,
			type: 0,
      show: !1,
			
			mode: this.$route.params.mode,
      oneinfo: {},
      stlist: [],
			
			// 批量操作相关
			checkList: {},
			batchBtnOptions: {},
			touchLong: false,
			showSearch: false,
    };
  },
  watch: {
  	touchLong: function() {
  		this.checkList = {};
  		this.$forceUpdate();
  	}
  },
  computed: {},
  methods: {
    async get_st_list() {
      this.stlist = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("incomeorder_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
				this.type = this.tabs[activeIndex].type;
      }
			
			this.setBatchBtnOption();
    },
    changeActiveIndex(value) {
			this.touchLong = false;
      this.cur = value;
			this.type = this.tabs[value].type;
      window.sessionStorage.setItem("incomeorder_activeIndex", value);
    },
    // 分页
    async onLoad() {
			this.loading = true;
			let type = this.tabs[this.cur]['type'];
			let params = JSON.parse(JSON.stringify(this.searchData));
			params.page = this.page;
			params.tag = type;
      let result = await this.$post(this.$api.stPayOrderReconcile, params);
      if (result.data.rows.length == 0) return (this.finished = true);
      // 进行操作
      this.stlist.push(...result.data.rows);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },

    onSearch() {
			this.touchLong = false;
      this.stlist= [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    clearSearch() {
      this.searchData = {};
      this.$forceUpdate();
      this.$toast("已清空搜索条件");
    },
    onCancel() {},
		
		// #region-start 批量操作相关方法
		// 开始触屏
		touchstart() {
			this.touchTimeOut = setTimeout(() => {
				this.touchLong = true;
			}, 2500)
		},
		touchmove() {
			clearTimeout(this.touchTimeOut);
		},
		touchend() {
			clearTimeout(this.touchTimeOut);
		},
		
		// 勾选
		checkItem(id) {
			this.checkList[id] = !this.checkList[id];
			this.$forceUpdate();
		},
		getCheckIds() {
			let ids = [];
			for (let i in this.checkList) {
				if (this.checkList[i]) {
					ids.push(i);
				}
			}
			
			return ids;
		},
		// 设置 批量操作的按钮
		setBatchBtnOption() {	
			let options = {};
			let oprator = {};
			let option = [
				{ text: '操作', children: [],
				}
			];
			
			for(let tit in this.tabs) {
				let v = this.tabs[tit];
				let children = [];
				if (v.type == 0) {
					children = [];
				}  else if (v.type == 1) {
					children = [];
				} else if (v.type == 2) {
					children = [];
				}
				if (children.length > 0)  options[v.type] = JSON.parse(JSON.stringify(option));
	
				children.forEach((child) => {
					if (options[v.type]) {
						options[v.type][0].children.push(oprator[child]);
					}
					
				})
			}
			
			this.batchBtnOptions = options;
		},
		// 批量处理
		batchCommand() {},
		
		// 更多里的操作
		headercommand(val) {
			this[val]();
		},
		// 打开搜索
		openShowSearch() {
			this.showSearch = true;
		},
		
		// 下载
		download() {
			let type = this.tabs[this.cur]['type'];
			let params = JSON.parse(JSON.stringify(this.searchData));
			params.tag = type;
			this.$post(this.$api.stPayOrderDownload,params).then((res) => {
				
				window.location.href = res.data;
			})
		},
		
		// 删除订单
		del(id, api) {
			this.$confirm('您正在进行客户删除操作，是否继续进行？').then(() => {
				this.$post(api, {ids: id}).then((res) => {
					if (res.code == 1) {
						this.$toast.success('删除成功');
						this.reload();
					} else {
						this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
					}
				})
			}).catch(() => {
				console.log('您取消了删除操作');
			});
		},
		// #region-edn 批量操作相关方法
		
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tab-content-list {
	padding-top: 0;
	position: relative;
	top: 0;
}
.st-list-box{
	margin: 12px 24px 10px;
	.st-list {
		border-radius: 5px;
	}
}
.st-header-right {
  .el-icon-circle-plus {
    font-size: 30px;
    transform: translateY(7px);
    color: rgba(42, 130, 228, 1);
  }
}

.keyword {
  position: relative;
	top: 0;
  width: 100%;
  z-index: 1;
  background-color: transparent;
  padding-top: 0;
  padding-bottom: 8px;
  margin-top: 66px;
  margin-bottom: 0;
	
	::v-deep .st-select .van-field {
		box-shadow: none!important;
	}
}

.keyword-panel {
  margin: 0 12px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eceff5;
  overflow: hidden;
}

.keyword-panel-head {
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f2f7;
}

.keyword-panel-title {
  font-size: 14px;
  color: #5c6575;
  font-weight: 600;
}

.keyword-panel-close {
  color: #8a93a3;
  font-size: 18px;
  line-height: 1;
}

.keyword-form {
  margin: 0;
}

.keyword-form-actions {
  padding: 12px;
  background-color: #fff;
}

.keyword-form-actions-split {
  display: flex;
  gap: 12px;
  .clearBtn,
  .submitBtn {
    flex: 1;
    height: 36px;
    border: none;
    border-radius: 6px;
    color: #fff;
    font-size: 14px;
    outline: none;
  }
  .clearBtn {
    background: #677588;
  }
  .submitBtn {
    background: #00baad;
  }
}

.keyword-collapsed {
  margin: 0 12px;
  height: 40px;
  border-radius: 10px;
  background: #fff;
  color: #8b95a7;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid #eceff5;
  box-shadow: none;
}

.st-list-bottom-xs {
  border-radius: 5px;
  font-size: 14px;
}

.four li {
  width: 25%;
}
.st-list-bottom-xs {
  background: #677588;
}
.pan-2 .t-tit {
  border-left: 3px solid #43cf7c;
}
.pan-3 .t-tit {
  border-left: 3px solid #ff5733;
}

.st-list-bottom-2,.st-list-bottom-3 {
	background-color: white;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
}

.st-list-bottom-2 {
	.van-button {
		margin-top: 8px;
		width: 45%;
		border-radius: 8px;
	}
}

.st-list-bottom-3 {
	.van-button {
		width: 30%;
		border-radius: 8px;
	}
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}

.st-list-main {
	position: relative;
  padding-top: 4px;
  padding-bottom: 4px;
  .st-field {
    display: flex;
    align-items: flex-start;
    padding: 6px 0;
    font-size: 14px;
    line-height: 1.5;
    border-bottom: 1px dashed #f1f3f7;
  }
  .st-field:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
  .st-field-label {
    flex: 0 0 96px;
    color: #7d8697;
  }
  .st-field-label::after {
    content: "：";
  }
  .st-field-value {
    flex: 1;
    min-width: 0;
    color: #394150;
    word-break: break-all;
  }
	.list-checkbox {
		position: absolute;
		top: 10px;
		right: 20px;
	}
}
</style>
<style lang="scss" scoped>
.tab-tilte.four {
  display: flex;
  overflow-x: hidden;
  height: 62px;
  min-height: 62px;
  align-items: center;
  padding: 2px 0 4px;
  box-sizing: border-box;
}
.tab-tilte.four .text-center {
  flex: 1;
  min-width: 0;
  height: 100%;
}
.tab-tilte.four .text-center span {
  font-size: 14px;
  line-height: 1;
}
.tab-tilte.four .active span {
  display: block;
  margin: 0 4px;
  padding: 10px 10px;
  border-radius: 999px;
}
.st-list-top-with-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.st-list-top-with-status .t-tit {
  flex: 1;
  min-width: 0;
}
.st-list-top-with-status .t-status {
  flex: 0 0 auto;
  color: #2a82e4;
  font-weight: 600;
}
.st-btn-3 {
	width: 30%;
	height: 50%;
	border-radius: 5px;
}
</style>
